import { Link } from "react-router-dom";
import { Instagram, Mail, Music2, Youtube, ArrowUpRight } from "lucide-react";

const COLUMNS = [
  {
    title: "Plateforme",
    links: [
      { label: "Découvrir Helencia", to: "/#decouvrir" },
      { label: "Comment ça marche", to: "/#how-it-works" },
      { label: "Helencia Premium", to: "/#premium-section" },
      { label: "Concours & événements", to: "/#concours-events" },
    ],
  },
  {
    title: "Ressources",
    links: [
      { label: "FAQ", to: "/faq" },
      { label: "CGU", to: "/cgu" },
      { label: "Mentions légales", to: "/mentions-legales" },
      { label: "Politique de confidentialité", to: "/confidentialite" },
    ],
  },
  {
    title: "Compte",
    links: [
      { label: "Connexion", to: "/login" },
      { label: "Inscription", to: "/register" },
      { label: "Contact", to: "mailto:hello@helencia.fr" },
    ],
  },
];

const SOCIALS = [
  { label: "Instagram", icon: Instagram, href: "https://instagram.com" },
  { label: "TikTok",    icon: Music2,    href: "https://tiktok.com" },
  { label: "YouTube",   icon: Youtube,   href: "https://youtube.com" },
  { label: "Email",     icon: Mail,      href: "mailto:hello@helencia.fr" },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white mt-0" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 pt-20 pb-10">
        {/* Top band — brand + newsletter */}
        <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3.5">
              <img src="/helencia-logo-256.png" alt="" width={56} height={56} className="rounded-2xl shadow-[0_5px_18px_-4px_rgba(0,0,0,0.4)]" style={{ width: 56, height: 56 }} />
              <p className="font-serif text-5xl leading-none text-white">Helencia</p>
            </div>
            <p className="caption-label text-[#E6C29A] mt-4">Plateforme des talents · Mode & Beauté</p>
            <p className="text-white/65 mt-6 max-w-md leading-relaxed">
              Une plateforme éditoriale qui relie talents créatifs et marques de mode. Portfolios, collaborations, castings, concours.
            </p>
            <div className="flex items-center gap-3 mt-8">
              {SOCIALS.map(({ label, icon: Icon, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#C68E59] text-white flex items-center justify-center transition"
                  data-testid={`footer-social-${label.toLowerCase()}`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <p className="caption-label text-[#E6C29A] mb-5">{col.title}</p>
                <ul className="space-y-3">
                  {col.links.map((l) => {
                    const external = l.to.startsWith("mailto:") || l.to.startsWith("http");
                    return (
                      <li key={l.label}>
                        {external ? (
                          <a href={l.to} className="text-sm text-white/80 hover:text-[#E6C29A] transition inline-flex items-center gap-1.5" data-testid={`footer-link-${l.label.toLowerCase()}`}>
                            {l.label} <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                          </a>
                        ) : (
                          <Link to={l.to} className="text-sm text-white/80 hover:text-[#E6C29A] transition" data-testid={`footer-link-${l.label.toLowerCase()}`}>
                            {l.label}
                          </Link>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Helencia — Tous droits réservés.</p>
          <p className="flex items-center gap-3">
            <span>Fait avec soin à Paris</span>
            <span className="w-1 h-1 rounded-full bg-white/40" />
            <span>contact@helencia.fr</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
